import { put, call, all, takeEvery } from 'redux-saga/effects';
import { repTempActionTypes } from '../actions/reportTemplateActionTypes';
import { processError } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted,
  processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';

export function* getReportTemplateCategoryList(action) {
  const { setCategoryList, locale } = action.data;
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_CATEGORY, null, { locale });
    setCategoryList(responseData);
    yield all([
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
}

const getDatasource = (datasource) => datasource.map((item) => ({
  value: item.dsCd,
  label: item.dsName,
}));

const getReportTemplateDatasourceList = function* (action) {
  const { selectedDataSources, locale, setDropdownItems } = action.data;
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_DATA_SOURCE, { locale, selectedDataSources: selectedDataSources || [] });
    const dataSourceList = getDatasource(responseData);
    setDropdownItems(dataSourceList);
    yield all([
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_DATASOURCE_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
};

const getReportTemplateDatasourceFieldList = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_FIELD_MAPPING, action.data);
    yield all([
      put(getAction(repTempActionTypes.SET_REPORT_TEMP_DATASOURCE_FEILD_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_DATASOURCE_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
};

const getReportTemplateSelfServiceList = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_LIST, action.data);
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_GRIDLIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
};

const getReportTemplateSelfServiceTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_TEMPLATE, action.data);
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_TEMPLATE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
};

const saveSsTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_TEMPLATE_SAVE, action.data);
    yield all([
      put(getAction(repTempActionTypes.SS_SAVE_UPDATE_TEMP_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
};

const updateSsTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.SELF_SERVICE_TEMPLATE_UPDATE, action.data);
    yield all([
      put(getAction(repTempActionTypes.SS_SAVE_UPDATE_TEMP_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
};

const getReportCenterListRequest = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.REPORT_CENTER_LIST, action.data);
    yield all([
      put(getAction(repTempActionTypes.SET_REPORT_CENTER_LIST_REQUEST, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const getReportCenterListRequestBYID = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SS_RESET_SERVER_VALUE, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GET_REPORT_CENTER_LIST_BYID, action.data);
    yield all([
      put(getAction(repTempActionTypes.SET_REPORT_CENTER_LIST_REQUEST_BY_ID, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const getTemplateSharedInfo = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.RESET_SHARE_REPORT_TEMPLATE_STORE, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GET_SHARE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(repTempActionTypes.GET_SHARE_REPORT_TEMPLATE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.SHARE_REPORT_TEMPLATE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};
const saveShareReportTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SAVE_SHARE_REPORT_TEMPLATE_RESPONSE, null)),
    put(getAction(repTempActionTypes.SHARE_REPORT_TEMPLATE_ERROR, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.SAVE_SHARE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(repTempActionTypes.SAVE_SHARE_REPORT_TEMPLATE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.SHARE_REPORT_TEMPLATE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const deleteReportTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.DELETE_REPORT_TEMPLATE_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.DELETE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(repTempActionTypes.DELETE_REPORT_TEMPLATE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.DELETE_REPORT_TEMPLATE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const getReportScheduleInfo = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.GET_REPORT_SCHEDULE_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GET_REPORT_SCHEDULE_INFO, null, { templateId: action.data.templateId });
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_SCHEDULE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.GET_REPORT_SCHEDULE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const saveReportScheduleInfo = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(repTempActionTypes.SAVE_REPORT_SCHEDULE_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.SAVE_REPORT_SCHEDULE_INFO, action.data);
    yield all([
      put(getAction(repTempActionTypes.SAVE_REPORT_SCHEDULE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(repTempActionTypes.SAVE_REPORT_SCHEDULE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};
const reportTemplateWatcher = function* () {
  yield takeEvery(repTempActionTypes.GET_REPORT_TEMP_CATEGORY_REQUEST, getReportTemplateCategoryList);
  yield takeEvery(repTempActionTypes.GET_REPORT_TEMP_DATASOURCE_LIST_REQUEST, getReportTemplateDatasourceList);
  yield takeEvery(repTempActionTypes.GET_REPORT_TEMP_DATASOURCE_FIELD_REQUEST, getReportTemplateDatasourceFieldList);

  yield takeEvery(repTempActionTypes.GET_REPORT_TEMP_LIST_REQUEST, getReportTemplateSelfServiceList);
  yield takeEvery(repTempActionTypes.SS_SAVE_TEMPLATE, saveSsTemplate);
  yield takeEvery(repTempActionTypes.SS_UPDATE_TEMPLATE, updateSsTemplate);

  yield takeEvery(repTempActionTypes.GET_REPORT_TEMP_TEMPLATE_REQUEST, getReportTemplateSelfServiceTemplate);
  yield takeEvery(repTempActionTypes.GET_REPORT_CENTER_LIST_REQUEST, getReportCenterListRequest);
  yield takeEvery(repTempActionTypes.GET_REPORT_CENTER_LIST_REQUEST_BY_ID, getReportCenterListRequestBYID);

  yield takeEvery(repTempActionTypes.GET_SHARE_REPORT_TEMPLATE_REQUEST, getTemplateSharedInfo);
  yield takeEvery(repTempActionTypes.SAVE_SHARE_REPORT_TEMPLATE_REQUEST, saveShareReportTemplate);

  yield takeEvery(repTempActionTypes.DELETE_REPORT_TEMPLATE_REQUEST, deleteReportTemplate);
  yield takeEvery(repTempActionTypes.GET_REPORT_SCHEDULE_REQUEST, getReportScheduleInfo);
  yield takeEvery(repTempActionTypes.SAVE_REPORT_SCHEDULE_REQUEST, saveReportScheduleInfo);
};

export default reportTemplateWatcher;
